import { regex } from './common'
const phone = /^[+]*[0-9]*$/

export default value => {
  return regex(value, phone)
}
